<script>
/* COMPOSANTS */
import AkDropdown from '@components/v2/input/AkDropdown.vue';
import AkInputText from '@components/v2/input/AkInputText.vue';
import AkAutocomplete from '@components/v2/input/AkAutocomplete.vue';
import MultiSelect from 'primevue/multiselect';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import sidebarMixin from '@/mixins/sidebarMixin';
import permissionsMixin from '@mixins/permissionsMixin';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import partenaireAutocompleteMixin from '@mixins/autocomplete/partenaireAutocompleteMixin';
import companyMixin from '@mixins/companyMixin';

export default {
  components: {
    AkButtonFooterSidebarFilter,
    AkInputText,
    AkDropdown,
    AkAutocomplete,
    MultiSelect,
  },
  mixins: [sidebarMixin, permissionsMixin, accommodationAutocompleteMixin, partenaireAutocompleteMixin, companyMixin],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  methods: {
    itemSelect() {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.$refs.accommodationAutocomplete.reset();
      this.$refs.partenaireAutocomplete.reset();
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-if="this.isGas()"
      v-model="currentValue.companyIds"
      :loading="this.loadingCompanies"
      :options="this.companies"
      :placeholder="$t('employee.company')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="name"
      option-value="id"
      @change="itemSelect" />
    <AkInputText
      v-model="currentValue.contactCompanyName"
      :placeholder="$t('contact.companyName')"
      @valueChange="itemSelect" />
    <AkAutocomplete
      ref="partenaireAutocomplete"
      v-model="currentValue.partenaireId"
      :init-method="autocompletePartenaireById"
      :inline="true"
      :placeholder="$t('partenaire.representant')"
      :search-method="autocompletePartenaire"
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />
    <AkAutocomplete
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :init-method="this.autocompleteAccommodationById"
      :inline="true"
      :minLengthToLaunchSearch="3"
      :placeholder="$t('accommodation_title')"
      :search-label="this.autocompleteAccommodationQuery"
      :search-method="this.autocompleteAccommodation"
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />
    <AkInputText
      v-model="currentValue.email"
      :placeholder="$t('client.email')"
      type="email"
      @valueChange="itemSelect" />
    <AkInputText v-model="currentValue.phone" :placeholder="$t('contact.phone')" type="tel" @valueChange="itemSelect" />
    <AkDropdown
      v-model="currentValue.userEnabled"
      :label="$t('status')"
      :options="[
        {label: $t('partenaire.all'), value: null},
        {label: $t('actives'), value: true},
        {label: $t('inactives'), value: false},
      ]"
      inline
      option-label="label"
      option-value="value"
      @valueChange="itemSelect" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search()" @reset="reset()" />
  </form>
</template>
